"use strict" ;

/**
* This constant is the Euler-Mascheroni constant (lambda or C) :
* <p>
* <pre>
* ( n )
* lim( sigma 1/k - ln(n) )
* n->oo ( k=1 )
* </pre>
* </p>
 * @name LAMBDA
 * @memberof core.maths
 * @instance
 * @const
*/
const LAMBDA = 0.57721566490143;

export default LAMBDA;
